module.exports = __webpack_public_path__ + "fonts/seguibl.868d9468.ttf";